import ApplicationModel, { attr } from '../ApplicationModel';
import { type AiUserAgentAttributes } from './generated/AiUserAgentAttributes';
import { model } from '../modelBuilder';

interface AiUserAgent extends AiUserAgentAttributes {}

@model
class AiUserAgent extends ApplicationModel {
  // Start auto-generated
  static typename: 'AiUserAgent' = 'AiUserAgent';
  get typename(): 'AiUserAgent' {
    return 'AiUserAgent';
  }

  static internalTypename: 'AiUserAgent' = 'AiUserAgent';
  get internalTypename(): 'AiUserAgent' {
    return 'AiUserAgent';
  }

  static inputType = 'AiUserAgentAttributes!';

  static filterType = 'AiUserAgentFilters!';
  static filters = {
    id: '[ID!]',
    projectId: 'ID',
    agentType: '[AgentTypeEnum!]',
  };

  static fields = {
    agentScope: attr({ readable: true }),
    agentType: attr({ writable: true, readable: true }),
    capabilities: attr({ readable: true }),
    categories: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    descriptionMarkdown: attr({ writable: true, readable: false }),
    favorite: attr({ writable: true, readable: false }),
    id: attr({ readable: true }),
    markdownInstruction: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    plans: attr({ readable: true }),
    slug: attr({ readable: true }),
    thumbnail: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({
      writable: true,
      readable: true,
      typename: 'Note',
    }),
    guideDescription: attr.belongsTo({ readable: true, typename: 'Note' }),
    longDescription: attr.belongsTo({ readable: true, typename: 'Note' }),
    shortDescription: attr.belongsTo({ readable: true, typename: 'Note' }),
  };
  // End auto-generated
}

export default AiUserAgent;
